import orderCareerByCategory from "./orderCareerByCategory"

export const matchMicrositeByCareer = ({
  micrositesAll,
  careersAll
}) => {

  const micrositesWithCareer = []

  micrositesAll.forEach((microsite) => {
    // Creating microsite
    const micrositeToPush = {
      name: microsite.name,
      color: microsite.color,
      coverImg: microsite.coverImg,
      careers: [],
      slug: microsite.slug
    }

    // Creating carrer of Microsite
    microsite.p_ucc_careers.forEach((career_relation) => {
      // Macheando la Unidad Organizacional con la carrera
      careersAll.forEach((careerItem) => { 
        if(career_relation.id === careerItem.id) {
          // Comprobamos que no sea Especialidad Cs Salud para ocultarla - 8 ID PROD / 12 ID DEV
          if (career_relation.career_category !== 8) {
            micrositeToPush.careers.push(careerItem)
          }
        }
      })
    })

    if (micrositeToPush.careers.length > 0)
      micrositesWithCareer.push(micrositeToPush)
    
      // Sort careers by category
      orderCareerByCategory(micrositeToPush.careers)
  })
  
  return micrositesWithCareer
}
